import Select from "../../shared/Select/Select";
import type { AcquisitionSource } from "../../../queries/acquisition/acquisitionSourceFilter";
import { AppStrings } from "../../../utils/constants/AppStrings";

type Props = {
  value: AcquisitionSource[];
  onChange: (value: AcquisitionSource[]) => void;
  loading?: boolean;
  className?: string;
  testId: string;
};

const AcquisitionSourceSelect = ({
  value,
  onChange,
  loading = false,
  className,
  testId,
}: Props) => (
  <Select
    mode="multiple"
    className={className}
    value={value}
    options={[
      {
        value: "referral_code",
        label: AppStrings.REFERRAL_CODE,
      },
      {
        value: "affiliate_code",
        label: AppStrings.PAM_ACQUISITION_SOURCE_AFFILIATE_CODE,
      },
      { value: "utm", label: AppStrings.PAM_ACQUISITION_SOURCE_UTM },
      {
        value: "organic",
        label: AppStrings.PAM_ACQUISITION_SOURCE_ORGANIC,
      },
    ]}
    onChange={(next) => onChange(next as AcquisitionSource[])}
    aria-label={AppStrings.SOURCE}
    placeholder={AppStrings.PAM_ACQUISITION_ALL_SOURCES}
    maxTagCount="responsive"
    showSearch
    optionFilterProp="label"
    loading={loading}
    data-testid={testId}
  />
);

export default AcquisitionSourceSelect;
